import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(({ spacing, palette }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    whiteSpace: 'normal',
    textAlign: 'center',
    maxWidth: '72px',
  },
  icon: {
    minWidth: 0,
  },
  selected: {
    color: '#50BC46',
    backgroundColor: 'transparent !important',
  },
}));
